import { CardsGrid } from '@app/components/base/content-structure/CardsGrid';
import { CardsGridItem } from '@app/components/base/content-structure/CardsGridItem';
import {
  CARDS_GRID_DENSE_COLUMNS,
  CARDS_GRID_DENSE_COLUMN_SPACING,
} from '@app/components/base/content-structure/cards-grid-config';
import { ListViewChildProps } from '@app/core/list-view/ListView';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { YoutubeBroadcast } from '../../youtube-broadcast-types';
import { YoutubeBroadcastCard } from '../card/YoutubeBroadcastCard';
import { YoutubeBroadcastsGridSkeleton } from './YoutubeBroadcastsGridSkeleton';
import { YOUTUBE_BROADCASTS_GRID_ITEM_SIZE } from './youtube-broadcasts-grid-constants';

export type YoutubeBroadcastsGridViewProps = ListViewChildProps<YoutubeBroadcast>;

/**
 * Renders YouTube broadcasts as a responsive grid of cards for the selected day.
 */
export function YoutubeBroadcastsGridView({
  data,
  isLoading = false,
}: YoutubeBroadcastsGridViewProps) {
  const station = useActiveStation();

  if (isLoading) {
    return <YoutubeBroadcastsGridSkeleton />;
  }

  return (
    <CardsGrid columns={CARDS_GRID_DENSE_COLUMNS} columnSpacing={CARDS_GRID_DENSE_COLUMN_SPACING}>
      {data.map((broadcast) => (
        <CardsGridItem
          size={YOUTUBE_BROADCASTS_GRID_ITEM_SIZE}
          key={`${broadcast.streamStartedAt}-${broadcast.streamEndedAt}`}
        >
          <YoutubeBroadcastCard broadcast={broadcast} stationSlug={station.slug} />
        </CardsGridItem>
      ))}
    </CardsGrid>
  );
}
